function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#F4F6F8"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 6l2-4h2v12H5l-2-4H2a1 1 0 01-1-1V7a1 1 0 011-1h1zM13 8a4 4 0 00-4-4V2a6 6 0 010 12v-2a4 4 0 004-4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 8a2 2 0 00-2-2v4a2 2 0 002-2z"
}));

var SvgSound = function SvgSound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24iPgo8ZyBpZD0iVmVjdG9yIj4KPHBhdGggZD0iTTMgNkw1IDJIN1YxNEg1TDMgMTBIMkMxLjQ0NzcyIDEwIDEgOS41NTIyOCAxIDlWN0MxIDYuNDQ3NzIgMS40NDc3MiA2IDIgNkgzWiIgZmlsbD0iI0Y0RjZGOCIvPgo8cGF0aCBkPSJNMTMgOEMxMyA1Ljc5MDg2IDExLjIwOTEgNCA5IDRWMkMxMi4zMTM3IDIgMTUgNC42ODYyOSAxNSA4QzE1IDExLjMxMzcgMTIuMzEzNyAxNCA5IDE0VjEyQzExLjIwOTEgMTIgMTMgMTAuMjA5MSAxMyA4WiIgZmlsbD0iI0Y0RjZGOCIvPgo8cGF0aCBkPSJNMTEgOEMxMSA2Ljg5NTQzIDEwLjEwNDYgNiA5IDZWMTBDMTAuMTA0NiAxMCAxMSA5LjEwNDU3IDExIDhaIiBmaWxsPSIjRjRGNkY4Ii8+CjwvZz4KPC9nPgo8L3N2Zz4K";
export { SvgSound as ReactComponent };